module.exports = __webpack_public_path__ + "img/hand-raise.32370532.svg";